/**
 * @description 全局注册组件  
 */
import app from '@/app';
import {defineAsyncComponent} from  'vue';

import MessageFactory from './ui-wrappers/message/index'
// 添加类型声明
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
      vknMessage: typeof MessageFactory,
    }
}

//////////////////////////////////////////////////////////////  ui 组件的二次封装  
//按钮
app.component(
    'vkn-button', 
    defineAsyncComponent(() => import('@/components/ui-wrappers/button/index.vue')) // 异步加载组件
)

// 表格
app.component(
    'vke-table',
    defineAsyncComponent(() => import('@/components/ui-wrappers/table/index.vue'))
)

// 进度条
app.component(
    'vkm-progressBar',
    defineAsyncComponent(() => import('@/components/modules/flight/progress/index.vue')) // 异步加载组件
)

// 场景选择
app.component(
    'vkm-sceneSelection',
    defineAsyncComponent(() => import('@/components/modules/sceneSelection/index.vue')) // 异步加载组件
)



app.config.globalProperties.vknMessage = MessageFactory;


//////////////////////////////////////////////////////////////  modules 组件库

// 三维引擎
app.component(
    'vkm-engineView',
    defineAsyncComponent(() => import('@/components/modules/engineView/index.vue')) // 异步加载组件
)  

//二次确认弹窗
app.component(
    'vkm-confirmModal',
    defineAsyncComponent(() => import('@/components/modules/confirmModal/index.vue'))
)

// 
app.component(
    'vkm-modal',
    defineAsyncComponent(() => import('@/components/modules/modal/index.vue'))
)


app.component(
    'vkm-svg',
    defineAsyncComponent(() => import('@/components/modules/svgIcon/index.vue')) // 异步加载组件
) 

app.component(
    'vkm-carousel',
    defineAsyncComponent(() => import('@/components/modules/carousel/index.vue'))
)

app.component(
    'vkm-loading3D',
    defineAsyncComponent(() => import('@/components/modules/loading3D/index.vue'))
)


app.component(
    'vkm-remoteStatus',
    defineAsyncComponent(() => import('@/components/modules/remoteStatus/index.vue'))
)

// 设置子页面通用布局
app.component(
    'vkm-settingChildPage',
    defineAsyncComponent(() => import('@/components/modules/settings/childPageLayout/index.vue'))
)

// caac-新手教学遥控器方向指导部分
app.component(
    'vkm-caacRemote',
    defineAsyncComponent(() => import('@/components/modules/flight/remote/index.vue'))
)
//caac-提示页面
app.component(
    'vkm-caacPrompt',
    defineAsyncComponent(() => import('@/components/modules/flight/promptPage/index.vue'))
)

//caac-飞行信息
app.component(
    'vkm-caacFlyInfo',
    defineAsyncComponent(() => import('@/components/modules/flight/flyInfo/index.vue'))
)

app.component(
    'vkm-flyDeviationInfo',
    defineAsyncComponent(() => import('@/components/modules/flight/flyInfo/flyDeviationInfo.vue'))
)

//caac-飞行成绩页面
app.component(
    'vkm-electricityGrade',
    defineAsyncComponent(() => import('@/components/modules/flight/grade/index.vue'))
)

// 视频播放器 
app.component(
    'vkm-videoPlayer',
    defineAsyncComponent(() => import('@/components/modules/videoPlayer/index.vue'))
)

// ai 教员
app.component(
    'vkm-aiInstructor',
    defineAsyncComponent(() => import('@/components/modules/aiInstructor/index.vue'))
)

//无人机碰撞弹窗
app.component(
    'vkm-uavCrash',
    defineAsyncComponent(() => import('@/components/modules/flight/uavCrash/index.vue'))
)

//通关成功弹窗
app.component(
    'vkm-passGrade',
    defineAsyncComponent(() => import('@/components/modules/flight/passGrade/index.vue'))    
)

//场景设置
app.component(
    'vkm-sceneSetting',
    defineAsyncComponent(() => import('@/components/modules/flight/sceneSetting/index.vue'))
)


const requireAll = (requireContext:any) => requireContext.keys().map(requireContext)
const req = require.context('@/assets/svg', false, /\.svg$/)
// 加载目录下的所有 svg 文件
requireAll(req)

